// extracted by mini-css-extract-plugin
export default {"mixAndMatchPaymentPromoContainer":"F9erN"};